import {
    RegularContainerSVG,
    RegularPercentageContainerSVG,
    GlassContainerSVG,
    GlassPercentageContainerSVG,
    QuestionSVG,
    RegularIslandSVG,
    BridgeWaterSVG,
    BridgeWaterPercentageSVG,
} from "./svgs";
const colors = {
    ot: "#808080",
    pg: "#FFFF00",
    pc: "#0000FF",
    gl: "#008000",
    oc: "#FFA500",
    rt: "#808080",
    ol: "#FF0000",
    tx: "#A52A2A",
    rg: "#3e8000",
    fl: "#6f00d1",
};

const WasteSelectorTypes = {
    fl: {
        name: "Bolseo",
        color: "#5e5e5e",
        fillColor: "#989898",
        borderColor: "#2c2c2c",
        contrastColor: "#d6d6d6",
        backgroundColor: "#838383",
        percent: 0,
        calendar: {
            id: "13",
            color: "#cbace8",
        },
        SVG: RegularIslandSVG,
        MarkerSVG: RegularIslandSVG,
    },
    ot: {
        name: "Resto",
        color: "#808080",
        fillColor: "#D1D3D3",
        borderColor: "#707070",
        contrastColor: "#A4A9AD",
        backgroundColor: "#E8E8E8",
        percent: 0,
        calendar: {
            id: "0",
            color: "#808080",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    pg: {
        name: "Envases",
        color: "#FFFF00",
        fillColor: "#FFE469",
        borderColor: "#D3A204",
        contrastColor: "#F7CA00",
        backgroundColor: "#FFF09F",
        percent: 0,
        calendar: {
            id: "1",
            color: "#D3A204",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    pc: {
        name: "Papel",
        color: "#0000FF",
        fillColor: "#89C8FD",
        borderColor: "#064A8B",
        contrastColor: "#26A5FD",
        backgroundColor: "#D1EAFF",
        percent: 0,
        calendar: {
            id: "2",
            color: "#064A8B",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    gl: {
        name: "Vidrio",
        color: "#008000",
        fillColor: "#49cb5c",
        borderColor: "#0c6c4a",
        contrastColor: "#028f5d",
        backgroundColor: "#89D894",
        percent: 0,
        calendar: {
            id: "3",
            color: "#0c6c4a",
        },
        SVG: GlassContainerSVG,
        MarkerSVG: GlassPercentageContainerSVG,
    },
    oc: {
        name: "Orgánica",
        color: "#FFA500",
        fillColor: "#CB9764",
        borderColor: "#7E4F22",
        contrastColor: "#B4763A",
        backgroundColor: "#E2B78C",
        percent: 0,
        calendar: {
            id: "4",
            color: "#7E4F22",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    rt: {
        name: "Restos",
        color: "#808080",
        fillColor: "#D1D3D3",
        borderColor: "#707070",
        contrastColor: "#A4A9AD",
        backgroundColor: "#E8E8E8",
        percent: 0,
        calendar: {
            id: "5",
            color: "#707070",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    ol: {
        name: "Aceite",
        color: "#FF0000",
        fillColor: "#F59955",
        borderColor: "#C96012",
        contrastColor: "#EB873C",
        backgroundColor: "#F4AB75",
        percent: 0,
        calendar: {
            id: "6",
            color: "#C96012",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    tx: {
        name: "Textil",
        color: "#A52A2A",
        fillColor: "#9864CB",
        borderColor: "#57227E",
        contrastColor: "#74499F",
        backgroundColor: "#C298EB",
        percent: 0,
        calendar: {
            id: "7",
            color: "#ffffff",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    rg: {
        name: "Reciclaje",
        color: "#3e8000",
        fillColor: "#49cb5c",
        borderColor: "#0c6c4a",
        contrastColor: "#028f5d",
        backgroundColor: "#89D894",
        percent: 0,
        calendar: {
            id: "8",
            color: "#0c6c4a",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    pr: {
        name: "Reciclaje",
        color: "#3e8000",
        fillColor: "#49cb5c",
        borderColor: "#0c6c4a",
        contrastColor: "#028f5d",
        backgroundColor: "#89D894",
        percent: 0,
        calendar: {
            id: "9",
            color: "#0c6c4a",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    ml: {
        name: "Metal",
        color: "#808080",
        fillColor: "#D1D3D3",
        borderColor: "#707070",
        contrastColor: "#A4A9AD",
        backgroundColor: "#E8E8E8",
        percent: 0,
        calendar: {
            id: "10",
            color: "#707070",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    bs: {
        name: "Pilas",
        color: "#6b6b6b",
        fillColor: "#6b6b6b",
        borderColor: "#000",
        contrastColor: "#C1863F",
        backgroundColor: "#b1b1b1",
        percent: 0,
        calendar: {
            id: "11",
            color: "#ffffff",
        },
        SVG: RegularContainerSVG,
        MarkerSVG: RegularPercentageContainerSVG,
    },
    none: {
        name: "Pilas",
        color: "#6c757d",
        fillColor: "#6c757d",
        borderColor: "#6c757d",
        contrastColor: "#6c757d",
        backgroundColor: "#6c757d",
        percent: 0,
        calendar: {
            id: "12",
            color: "#ffffff",
        },
        SVG: QuestionSVG,
        MarkerSVG: QuestionSVG,
    },
    br: {
        name: "Bridge",
        color: "#6c757d",
        fillColor: "#6c757d",
        borderColor: "#6c757d",
        contrastColor: "#6c757d",
        backgroundColor: "#6c757d",
        percent: 0,
        calendar: {
            id: "13",
            color: "#ffffff",
        },
        SVG: BridgeWaterSVG,
        MarkerSVG: BridgeWaterPercentageSVG,
    },
    getBackgroundColor: function (type) {
        return this[type].backgroundColor;
    },
    getColor: function (type) {
        return this[type].color;
    },
    getBorderColor: function (type) {
        return this[type].borderColor;
    },
    getName: function (type) {
        return this[type].name;
    },
    getStyle: function (type) {
        return {
            color: this.getColor(type),
            fillColor: this.getBackgroundColor(type),
            borderColor: this.getBorderColor(type),
        };
    },
};
export default WasteSelectorTypes;
